import 'date-fns';
import React, { useEffect, useRef } from 'react';
import MaterialTable from 'material-table'

export default function MaterialTableComponent(props) {

  const downloadCsv = (data, fileName) => {
    const finalFileName = fileName.endsWith(".csv") ? fileName : `${fileName}.csv`;
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
    a.setAttribute("download", finalFileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  const tableRef = useRef();
  
  return (
    <MaterialTable
      localization={{
        toolbar: {
          exportCSVName: "Exportar para CSV",
          exportPDFName: "Imprimir",
          searchPlaceholder: "Busca",
          searchAriaLabel: "Busca",
          clearSearchAriaLabel: "Limpar Busca",
          searchTooltip: "Busca",
        },
        addRemoveColumns: "Add or remove columns",
        nRowsSelected: "{0} row(s) selected",
        showColumnsTitle: "Show Columns",
        showColumnsAriaLabel: "Show Columns",
        exportTitle: "Exportar",
        exportAriaLabel: "Exportar",
        body: {
          emptyDataSourceMessage: 'Não há registros a serem exibidos',
          filterRow: {
            filterTooltip: 'Filtro'
          }
        },
        header: {
          actions: 'Ações'
        },
        pagination: {
          labelRowsSelect: 'Registros',
          previousAriaLabel: 'Página anterior',
          previousTooltip: 'Página anterior',
          nextAriaLabel: 'Próxima página',
          nextTooltip: 'Próxima página',
          lastAriaLabel: 'Última página',
          lastTooltip: 'Última página',
          firstAriaLabel: 'Primeira página',
          firstTooltip: 'Primeira página',
        },
      }}
      {...props}
    />
  );
}